import { ErrorInfo, Component } from 'react';

import Error404 from '../Error404';
import { logToBackend } from 'src/helpers/BackendLogger';


interface IErrorBoundary {
    children: React.ReactNode;
}

interface IErrorBoundaryState {
    error?: Error | null;
    errorInfo?: ErrorInfo | null;
}

class ErrorBoundary extends Component<IErrorBoundary, IErrorBoundaryState> {
    constructor(props: IErrorBoundary) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    async logErrorToDatadog(error: Error, errorInfo: ErrorInfo) {
        const errorMessage = error.toString();
        const errorDetails = {
            stack: error.stack,
            componentStack: errorInfo.componentStack,
        };

        await logToBackend(errorMessage, errorDetails.toString());
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // eslint-disable-next-line no-console
        console.log('log error ---', error);
        // eslint-disable-next-line no-console
        console.log('log error info ---', errorInfo);

        this.logErrorToDatadog(error, errorInfo);
    }

    clearErrorState = () => {
        this.setState({ error: null, errorInfo: null });
    }

    render() {
        if (this.state.errorInfo || this.state.error) {
            return (
                <Error404 clearErrorState={this.clearErrorState}/>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
